const DATE_ONLY_FIELDS = new Set([
  'activation_date',
  'management_start_date',
]);

const DATE_TIME_FIELDS = new Set([
  'accepted_at',
  'status_changed_at',
]);

const REQUEST_TYPE_FIELDS = new Set([
  'type',
  'other_action',
  'original_type',
  'original_action',
  'supply_type',
]);

const isEmpty = (value) => value === null || value === undefined || value === '';

const humanizeIdentifier = (value) => {
  const text = String(value ?? '').replaceAll('_', ' ').replaceAll('-', ' ').trim();
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : '—';
};

export const createRequestHistoryFormatter = ({ t, te, formatDate }) => {
  const fieldLabel = (field) => {
    const key = `requestHistory.fields.${field}`;
    return te(key) ? t(key) : humanizeIdentifier(field);
  };

  const translatedValue = (value, field) => {
    const historyKey = `requestHistory.values.${value}`;
    if (te(historyKey)) return t(historyKey);

    if (REQUEST_TYPE_FIELDS.has(field)) {
      const typeKey = `common.requestTypes.${value}`;
      if (te(typeKey)) return t(typeKey);
    }

    const statusKey = `common.requestStatus.${value}`;
    if (te(statusKey)) return t(statusKey);

    return typeof value === 'string' && /^[a-z0-9_-]+$/i.test(value)
      ? humanizeIdentifier(value)
      : String(value);
  };

  const formatValue = (value, entry = null, field = null) => {
    if (isEmpty(value)) return '—';

    if (DATE_ONLY_FIELDS.has(field)) return formatDate(value, true);
    if (DATE_TIME_FIELDS.has(field)) return formatDate(value);

    // Gestor asignado y administrador se guardan por id: la API devuelve a quién
    // corresponde cada uno para que la reasignación se lea (ADS-0076).
    const person = typeof value !== 'object' ? entry?.people?.[value] : null;
    if (person) return person;

    if (typeof value === 'boolean') return value ? t('requestHistory.yes') : t('requestHistory.no');

    if (Array.isArray(value)) {
      return value.map((item) => formatValue(item, entry, field)).join(' · ') || '—';
    }

    if (typeof value === 'object') {
      return Object.entries(value)
        .map(([nestedField, nestedValue]) => (
          `${fieldLabel(nestedField)}: ${formatValue(nestedValue, entry, nestedField)}`
        ))
        .join(' · ') || '—';
    }

    return translatedValue(value, field);
  };

  return { fieldLabel, formatValue };
};
